module.exports = __webpack_public_path__ + "img/greenSleeve.201b8f35.gif";